import React from 'react';
import packageJson from '~root/package.json';

import { Wrapper } from './styles';

interface AppVersionProps {
  includeEnv?: boolean;
}

const AppVersion: React.FC<AppVersionProps> = ({ includeEnv = true }) => {
  const env = process.env.REACT_APP_ENV;
  return (
    <Wrapper className="app-version">
      {includeEnv && env !== 'prod' && <span className="name">{env}</span>}
      <span className="version">{packageJson.version}</span>
    </Wrapper>
  );
};

export default AppVersion;
